import { render } from "./AddPlatformModal.vue?vue&type=template&id=2f21f8bc&scoped=true"
import script from "./AddPlatformModal.vue?vue&type=script&lang=js"
export * from "./AddPlatformModal.vue?vue&type=script&lang=js"

import "./AddPlatformModal.vue?vue&type=style&index=0&id=2f21f8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f21f8bc"],['__file',"src/components/modals/AddPlatformModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f21f8bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f21f8bc', __exports__)) {
    api.reload('2f21f8bc', __exports__)
  }
  
  module.hot.accept("./AddPlatformModal.vue?vue&type=template&id=2f21f8bc&scoped=true", () => {
    api.rerender('2f21f8bc', render)
  })

}


export default __exports__